"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRevokeUserFromCommunityPoolResponseToJSON = exports.AdminRevokeUserFromCommunityPoolResponseFromJSONTyped = exports.AdminRevokeUserFromCommunityPoolResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminRevokeUserFromCommunityPoolResponseFromJSON(json) {
    return AdminRevokeUserFromCommunityPoolResponseFromJSONTyped(json, false);
}
exports.AdminRevokeUserFromCommunityPoolResponseFromJSON = AdminRevokeUserFromCommunityPoolResponseFromJSON;
function AdminRevokeUserFromCommunityPoolResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'revokedAt': !(0, runtime_1.exists)(json, 'revokedAt') ? undefined : (new Date(json['revokedAt'])),
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.AdminRevokeUserFromCommunityPoolResponseFromJSONTyped = AdminRevokeUserFromCommunityPoolResponseFromJSONTyped;
function AdminRevokeUserFromCommunityPoolResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'userId': value.userId,
        'revokedAt': value.revokedAt === undefined ? undefined : (value.revokedAt.toISOString()),
        'message': value.message,
    };
}
exports.AdminRevokeUserFromCommunityPoolResponseToJSON = AdminRevokeUserFromCommunityPoolResponseToJSON;
